<div class="zk-pt-3 search-wrapper" [ngClass]="{ 'search-background': hasBackground }">
	<button
		class="zk-flex zk-justify-end search-close-icon"
		*ngIf="form?.value?.search?.length > 0"
		(click)="cleanSearch()"
	>
		<span class="freud-icon freud-icon-close freud-icon-md"></span>
</button>
	<freud-input-text
		ngDefaultControl
		[formControl]="form.controls.search"
		(valueChange)="search()"
		rightIcon="freud-icon-search"
		label="{{ 'SESSION.SIDEBAR.VC_SEARCH_LABEL' | translate }}"
		placeholder="{{ 'SESSION.SIDEBAR.VC_SEARCH_PLACEHOLDER' | translate }}"
	></freud-input-text>
</div>

<div class="results" *ngIf="isLoaded || isLoading">
	<div class="empty-state" *ngIf="searchResults.length === 0 && isLoaded">
		<div class="no-registers" *ngIf="form.value.search === ''">
			<span class="no-registers__text">{{
				'SESSION.SIDEBAR.VC_NO_REGISTERS' | translate
			}}</span>
			<span *ngIf="mode !== 'appointment'" class="no-registers__description">{{
				'SESSION.SIDEBAR.VC_NO_REGISTERS_DESCRIPTION' | translate
			}}</span>
			<freud-button *ngIf="mode !== 'appointment'" (keyup)="$event.key === 'Enter' ? redirectToDocumentaryRegister.emit() : null" (click)="redirectToDocumentaryRegister.emit()">{{
				'SESSION.SIDEBAR.VC_NO_REGISTERS_BUTTON' | translate
			}}</freud-button>
		</div>
		<div class="empty-results" *ngIf="form.value.search !== '' && isLoaded">
			<span class="empty-results__text">{{
				'SESSION.SIDEBAR.VC_EMPTY_SEARCH' | translate
			}}</span>
			<freud-button (click)="cleanSearch()">{{
				'SESSION.SIDEBAR.VC_CLEAN_SEARCH' | translate
			}}</freud-button>
		</div>
	</div>
	<div class="history__list zk-mt-2" [ngClass]="{'extended': extendedList}">
		<ng-container *ngIf="searchResults.length > 0">
			<div class="zk-flex zk-flex-col zk-gap-4" *ngIf="useAccordion">
				<ng-container *ngFor="let resultItem of searchResults" >
					<accordion *ngIf="resultItem.serviceEvolution" [isOpen]="true" [title]="formatTitle(resultItem)"
						icon="file-text">
						<p class="history__description"freud-typography fontType="h5RegularAuto">
							{{ resultItem.serviceEvolution }}
						</p>
					</accordion>
				</ng-container>
			</div>
			<ng-container *ngIf="!useAccordion">
				<vc-history-card
				class="zk-mt-3"	
				*ngFor="let resultItem of searchResults"
				[date]="resultItem.createdAt"
				[note]="resultItem.serviceEvolution"
				[highlightIndexes]="resultItem.indices">
				</vc-history-card>	
			</ng-container>
		</ng-container>
		<div *ngIf="isLoading" class="zk-flex zk-h-40 zk-justify-center zk-items-center">
			<freud-loader></freud-loader>
		</div>
	</div>
	
	<div class="zk-flex zk-justify-center zk-pt-4" *ngIf="searchResults.length > 0 && !resultsHasEnded && isLoaded">
		<freud-button [loading]="isLoadingMore" #target (click)="loadMore(target)">{{
			'SESSION.SIDEBAR.LOAD_MORE' | translate
		}}</freud-button>
	</div>
</div>
